(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptLanguageDetailController', RptLanguageDetailController);

    RptLanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptLanguage'];

    function RptLanguageDetailController($scope, $rootScope, $stateParams, previousState, entity, RptLanguage) {
        var vm = this;

        vm.rptLanguage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptLanguageUpdate', function(event, result) {
            vm.rptLanguage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
